import { create, httpClient } from '@/utils/http-client';
import appConfig from '@/config';
export default class UserService {
    httpClient;
    apiClient;
    constructor() {
        this.httpClient = create(appConfig.wpURL);
        this.apiClient = httpClient;
    }
    async sendLogin() {
        return this.apiClient.post('/users/login-stat', {
            metadata: window.uData
        });
    }
    async updatePersonalInfo(firstName, lastName, avatarLink, automatic = true) {
        return this.apiClient.put('/users/userinfo/update', {
            firstName,
            lastName,
            avatarLink,
            automatic
        });
    }
    async updateBrandkit(automatic = true) {
        if (!window.brandKit)
            return console.warn('User has no brandkit');
        return this.apiClient.put('/users/brandkit/update', {
            brandKit: window.brandKit,
            automatic // Temporary messure. We were previosuly storing allt he brandkit information for users on the wordpress application. We need to send this as a flag to know if we should store the brandkit updates "automatically" or not. TODO: Remove in a couple of weeks when all users have stored their brandkit on the new DB
        });
    }
    async getUser() {
        const response = await this.apiClient.get('/users/user');
        return response.data;
    }
    async getBrandKit() {
        const response = await this.httpClient.get(`/custom-code/php/brand-kit/get-brand-kit.php`);
        return response.data;
    }
    async getBrandKitFromApi() {
        const response = await this.apiClient.get('/users/brandkit');
        return response.data;
    }
    async deleteCurrentLogo(logoURL) {
        const formData = new FormData();
        formData.append('imageName', logoURL);
        await this.httpClient.post('/custom-code/php/brand-kit/delete-image.php', formData);
    }
    async uploadBrandLogo(file, useApi = false) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            let random = Math.random().toString(36).substring(2, 10);
            let filename = random + '-' + file.name;
            //replace unique characters with hyphen
            filename = filename.replace(/[^a-zA-Z0-9]/g, '-');
            reader.onload = async (e) => {
                const sendToWp = async () => {
                    try {
                        const formData = new FormData();
                        formData.append('type', 'canvas');
                        formData.append('folder', 'brandKit');
                        formData.append('inUserFolder', 'yes');
                        formData.append('fileToSave', e.target.result);
                        formData.append('name_of_file', filename);
                        const response = await this.httpClient.post('/custom-code/php/save-image-to-server.php', formData);
                        resolve(filename);
                    }
                    catch (err) {
                        reject(err);
                    }
                };
                const sendToApi = async () => { };
                if (useApi) {
                    await sendToApi();
                }
                else {
                    await sendToWp();
                }
            };
            reader.onerror = error => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }
    async saveBrandKit(brandkit) {
        const formData = new FormData();
        formData.set('brandKit', JSON.stringify(brandkit));
        await this.httpClient.post('/custom-code/php/queries/save-brand-kit.php', formData);
    }
    async addTrial(payload) {
        const response = await this.apiClient.post('/users/trial', payload);
        return response.data;
    }
    async updatePreferences(payload) {
        const response = await this.apiClient.patch('/users/preferences', payload);
        return response.data;
    }
}
